import React, { useEffect, useRef, useState } from 'react';
import mapboxgl from 'mapbox-gl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faUnlock } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';

import styles from './styles.module.scss';
import errorMsg from '../../Functions/errorMsg';

const MapWithRadius = ({ zipCode }) => {
  console.log(zipCode);
  const mapContainer = useRef(null);
  const [center, setCenter] = useState(null);
  const [radius, setRadius] = useState(3);
  const [map, setMap] = useState(null);
  const [mapInteractive, setMapInteractive] = useState(false);

  useEffect(() => {
    const fetchCoordinates = async () => {
      try {
        const response = await axios.get(`https://api.mapbox.com/geocoding/v5/mapbox.places/${zipCode}.json?bbox=-171.791110603,18.91619,-66.96466,71.3577635769&access_token=pk.eyJ1Ijoid2Fjb2V4Y2hhbmdlIiwiYSI6ImNsdDI3bnFvbTByODQybXF4bnV6eHZvNW0ifQ.b1kQixq2mV4ChcEys0i4XQ`);
        const { features } = response.data;
        if (features && features.length > 0) {
          const { center } = features[0];
          setCenter(center);
          setRadius(3);
        }
      } catch (error) {
        errorMsg("Could not locate this ZIP code.");
      }
    };

    fetchCoordinates();
  }, [zipCode]);

  useEffect(() => {
    if (!center) return;

    mapboxgl.accessToken = 'pk.eyJ1Ijoid2Fjb2V4Y2hhbmdlIiwiYSI6ImNsdDI3bnFvbTByODQybXF4bnV6eHZvNW0ifQ.b1kQixq2mV4ChcEys0i4XQ';
    const initializedMap = new mapboxgl.Map({
      container: mapContainer.current,
      style: 'mapbox://styles/wacoexchange/clt29tbhd01w901p471g3hcj3',
      center,
      zoom: 12,
      interactive: false,
    });

    setMap(initializedMap);

    const calculateBoundaryPoints = (center, radius) => {
      const R = 6371;
      const lat1 = center[1] * Math.PI / 180;
      const lng1 = center[0] * Math.PI / 180;
      const d = radius / R;
      const boundaryPoints = [];
      for (let i = 0; i <= 360; i += 10) {
        const brng = i * Math.PI / 180;
        const lat2 = Math.asin(Math.sin(lat1) * Math.cos(d) + Math.cos(lat1) * Math.sin(d) * Math.cos(brng));
        const lng2 = lng1 + Math.atan2(Math.sin(brng) * Math.sin(d) * Math.cos(lat1), Math.cos(d) - Math.sin(lat1) * Math.sin(lat2));
        boundaryPoints.push([lng2 * 180 / Math.PI, lat2 * 180 / Math.PI]);
      }
      return boundaryPoints;
    };

    initializedMap.on('load', () => {
      const boundaryPoints = calculateBoundaryPoints(center, radius);
      initializedMap.addLayer({
        id: 'circle',
        type: 'fill',
        source: {
          type: 'geojson',
          data: {
            type: 'Feature',
            geometry: {
              type: 'Polygon',
              coordinates: [boundaryPoints],
            },
          },
        },
        paint: {
          'fill-color': '#154734',
          'fill-opacity': 0.35,
        },
      });

      const bounds = boundaryPoints.reduce((bounds, point) => {
        return bounds.extend(point);
      }, new mapboxgl.LngLatBounds(boundaryPoints[0], boundaryPoints[0]));
      initializedMap.fitBounds(bounds, { padding: 20 });
    });

    return () => initializedMap.remove();
  }, [center, radius]);

  useEffect(() => {
    if (map) {

      if (mapInteractive) {
        map.boxZoom.enable();
        map.scrollZoom.enable();
        map.dragPan.enable();
        map.dragRotate.enable();
        map.keyboard.enable();
        map.doubleClickZoom.enable();
      } else {
        map.boxZoom.disable();
        map.scrollZoom.disable();
        map.dragPan.disable();
        map.dragRotate.disable();
        map.keyboard.disable();
        map.doubleClickZoom.disable();
      }
    }
  }, [map, mapInteractive]);

  const toggleMapInteraction = () => {
    setMapInteractive(!mapInteractive);
  };

  return (
    <div id={styles.wrapper}>
      <div id={styles.container}>
        <div ref={mapContainer} style={{ width: '100%' }} />
        <div style={{ position: 'absolute', top: '10px', left: '10px', zIndex: 99 }}>
          <button id={styles.toggleInteraction} onClick={toggleMapInteraction}>
            {mapInteractive ? <FontAwesomeIcon icon={faUnlock} id={styles.icon} /> : <FontAwesomeIcon icon={faLock} id={styles.icon} />}
          </button>
        </div>
      </div>
    </div>

  );
};

export default MapWithRadius;
